// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const AssignTaskConfirmationDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-assignTaskConfirmationDialogContainer" */ "./AssignTaskConfirmationDialogContainer")).then((bundle)=>{
        return {
            default: bundle.AssignTaskConfirmationDialogContainer
        };
    });
export const LazyAssignTaskConfirmationDialogContainer = /*#__PURE__*/ lazy(AssignTaskConfirmationDialogContainerLazyLoader);
